import { lessonByKey } from "@mathtrain/engine";
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { api } from "../lib/api";

export function Lesson() {
  const { key } = useParams();
  const nav = useNavigate();
  const lesson = key ? lessonByKey(key) : undefined;
  const [shown, setShown] = useState<Set<number>>(new Set());
  const [read, setRead] = useState(false);
  if (!lesson) return <main className="page bare"><h1>No such lesson</h1><Link className="btn" to="/grow">Back to Grow</Link></main>;
  const reveal = (i: number) => setShown(new Set(shown).add(i));
  const markRead = async () => { try { await api(`/lessons/${lesson.key}/read`, { body: {} }); setRead(true); } catch { /* shown on next load */ } };
  return <main className="page bare">
    <button className="btn quiet" onClick={() => nav(-1)}>‹ Back</button>
    <h1>{lesson.title}</h1>
    <p className="mute">{lesson.blurb}</p>
    <ol className="steps">{lesson.steps.map((s, i) => <li key={i}>{s}</li>)}</ol>
    {lesson.examples.length > 0 && <>
      <h2>Try it in your head</h2>
      <p className="small mute" style={{ marginTop: 0 }}>Work it out first, then tap to see the steps.</p>
      {lesson.examples.map((ex, i) => <div className="card" key={i}>
        <div className="card-head" style={{ marginBottom: 0 }}><span className="card-title">{ex.q}</span>
          {!shown.has(i) && <button className="btn ink" style={{ padding: "8px 14px" }} onClick={() => reveal(i)}>Show steps</button>}</div>
        {shown.has(i) && <div style={{ marginTop: 8 }}>{ex.walk} <b>= {ex.answer.toLocaleString("en-US")}</b></div>}
      </div>)}
    </>}
    <div className="card" style={{ marginTop: 16 }}>
      <div className="small mute">When to use it</div><div>{lesson.when}</div>
      <div className="small mute" style={{ marginTop: 8 }}>Watch out for</div><div>{lesson.watch}</div>
    </div>
    <p className="mute" style={{ marginTop: 12 }}>{lesson.tip}</p>
    <div className="stack" style={{ marginTop: 16 }}>
      {lesson.skill !== "general" && <button className="btn-primary" onClick={() => nav("/play", { state: { mode: "drill", skill: lesson.skill, level: lesson.level, lesson: lesson.key } })}>
        Practice 5 problems</button>}
      {lesson.skill !== "general" && <p className="small mute" style={{ margin: 0 }}>Get 4 of 5 right and this lesson counts as learned. Hints are fine.</p>}
      <button className="btn" disabled={read} onClick={markRead}>{read ? "Marked as read" : "Mark as read"}</button>
    </div>
  </main>;
}
